import type { CaseGrade, CaseStage } from "../index";

export type CaseCheckCasesPageParams = {
  skip: number;
  limit: number;
  stage?: CaseStage;
  grade?: CaseGrade;
};

export const caseCheckKeys = {
  all: ["case-checking"] as const,
  casesPage: (params: CaseCheckCasesPageParams) => [...caseCheckKeys.all, "cases-page", params] as const,
  casesAll: (params?: { stage?: CaseStage; grade?: CaseGrade }) =>
    [...caseCheckKeys.all, "cases-all", params ?? {}] as const,
  missionStatus: (caseIds: readonly string[]) =>
    [...caseCheckKeys.all, "mission-status", [...caseIds].sort().join(",")] as const,
  detail: (caseId: string) => [...caseCheckKeys.all, "case", caseId] as const,
};
